module.exports = __webpack_public_path__ + "assets/dada8fc74b16eacdfc28e5f7795118b4.jpg";